import { IDR } from '@/libs/currency'

const columnConfig = [
  {
    key: 'checkbox',
    label: '',
    thClass: 'pr-0 align-middle',
    tdClass: 'pr-0',
  },
  {
    key: 'index',
    label: 'No',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '20px',
      textAlign: 'left',
      fontWeight: 600,
    },
    tdStyle: {
      textTransform: 'capitalize',
      fontSize: '110px',
      color: '#333333',
      minWidth: '150px',
      textAlign: 'left',
    },
    tdClass: 'text-red',
  },
  {
    key: 'name',
    label: 'Kartu',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '300px',
      textAlign: 'left',
      fontWeight: 600,

    },
    tdStyle: {
      textTransform: 'capitalize',
      fontSize: '110px',
      color: '#333333',
      minWidth: '150px',
      textAlign: 'left',
    },
    tdClass: 'text-red',
  },
  {
    key: 'daily_limit',
    label: 'Limit Harian',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '200px',
      textAlign: 'center',
      fontWeight: 600,
    },
    tdClass: 'text-center',
    formatter: value => IDR(value),
  },
  {
    key: 'decline_transactions',
    label: 'Decline Transaksi',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '250px',
      textAlign: 'left',
      fontWeight: 600,
    },
  },
  {
    key: 'spending_category',
    label: 'Kategori Spending',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '250px',
      textAlign: 'left',
      fontWeight: 600,
    },
  },
  {
    key: 'spending',
    label: 'Spending',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '200px',
      textAlign: 'left',
      fontWeight: 600,
    },
    formatter: value => IDR(value),
  },
  {
    key: 'balance',
    label: 'Saldo Kartu',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '200px',
      textAlign: 'left',
      fontWeight: 600,
      textWrap: 'nowrap',
    },
    formatter: value => IDR(value),
  },
  {
    key: 'more',
    label: '',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '100px',
      textAlign: 'left',
      fontWeight: 600,
    },
  },
]

export default columnConfig
